var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.141,
    height: 16.143,
    viewBox: "0 0 16.141 16.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.07 -8.9) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.707-.707,10,10-.707,10.707,0Z",
    transform: "translate(7 7)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,17.5h-1V7.5H6.5v-1h11Z",
    fill: "#dfe1e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.62d8821555c495184c47f9b13eb15868.svg";
export { ForwardRef as ReactComponent };